
export enum TypeShiftLimitEnum {
  MAXIMO = "MAXIMO",
  MAXIMO_PERMITIR_BALANCES_NEGATIVO = "MAXIMO_PERMITIR_BALANCES_NEGATIVO",
  MINIMO = "MINIMO"
}